import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Debasish Behera. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
